module.exports = __webpack_public_path__ + "img/ios.f37ba83d.png";